export const api = {

    products: {
        details: (productId: number | string) =>
            `/products/productdetails?productId=${productId}`,

        otcUrl: (productId: number | string) =>
            `/products/GetOtcPraeparatUrl?productId=${productId}`,

        praeparatUrl: (productId: number | string, praeparatId: number | string) =>
            `/products/GetPraeparatNodeUrl?productId=${productId}&praeparatId=${praeparatId}`,

        excludedOtcs: `/products/GetExcludedOtcs`,
        
        allOtcCategories: `/products/GetAllOtcCategories`,
    },

    search: {
        praeparatById: (id: number | string) =>
            `/search/GetPraeparatById?id=${id}`,

        suggestPraeparatName: (keyword: string) =>
            `/search/SuggestPraeparatName?keyword=${encodeURIComponent(keyword)}`,

        suggestFullText: (keyword: string) =>
            `/search/SuggestFulltext?keyword=${encodeURIComponent(keyword)}`,

        fullText: (keyword: string, start:number, take:number) =>
            `/search/FullTextSearch?keyword=${encodeURIComponent(keyword)}&start=${encodeURIComponent(start)}&take=${encodeURIComponent(take)}`,

        letterIndex: (letter: string) =>
            `/search/PraeparatFirstCharSearch?letter=${letter}`,

        otcCategorySearch: `/search/OtcCategorySearch`,
        searchCategories: `/search/GetSearchCategories`,
        praeparateSearchCount: `/search/GetPraeparateSearchCountSettings`,

        content: {
            suggest: (keyword: string) =>
                `/search/ContentSuggestFullText?keyword=${encodeURIComponent(keyword)}`,
            fullText: (keyword: string, category:string,start:number, take:number) =>
                `/search/ContentFullTextSearch?keyword=${encodeURIComponent(keyword)}&category=${encodeURIComponent(category)}&start=${encodeURIComponent(start)}&take=${encodeURIComponent(take)}`,
        },

        media: {
            suggest: (keyword: string) =>
                `/search/MediaSuggestFullText?keyword=${encodeURIComponent(keyword)}`,
            fullText: (keyword: string, start:number, take:number) =>
                `/search/MediaFullText?keyword=${encodeURIComponent(keyword)}&start=${encodeURIComponent(start)}&take=${encodeURIComponent(take)}`,
        },
        news: {
            getCategories:()=>
                "/search/GetNewsCategories",
            getNews:(keyword:string, start:number, take:number) =>
                `/search/GetNews?keyword=${encodeURIComponent(keyword)}&start=${encodeURIComponent(start)}&take=${encodeURIComponent(take)}`,
            getIframe:(alias:string) => 
                `/search/getIframe?alias=${encodeURIComponent(alias)}`,
        },

        // news: {
        //     suggest: (keyword: string) =>
        //         `/search/NewsSuggestFullText?keyword=${encodeURIComponent(keyword)}`,
        //     fullText: (keyword: string) =>
        //         `/search/NewsFullTextSearch?keyword=${encodeURIComponent(keyword)}`,
        //     highlighted: (category: string) =>
        //         `/search/GetHighlightedNews?category=${encodeURIComponent(category)}`,
        //     byCategory: (category: string) =>
        //         `/search/GetNewsByCategory?category=${encodeURIComponent(category)}`,
        //     byId: (id: number | string) =>
        //         `/search/GetNewsById?id=${id}`,
        // },
    },
    resources: {
        rabattVertraege: (praeparatId: number | string) =>
            `/ressourcen/GetRabattvertraege?praeparatId=${praeparatId}`,

        dictionaryArea: (area: string) =>
            `/ressourcen/GetDictionaryItems?area=${encodeURIComponent(area)}`,

        publicImageApi: `/ressourcen/getpublicimageapiurl`,
        pflichttextUrl: `/ressourcen/GetPflichttextUrl`,
    },
      
    downloads: {
        all: (letter: string, start:number, take:number) =>
                `/search/Downloads?letter=${encodeURIComponent(letter)}&start=${encodeURIComponent(start)}&take=${encodeURIComponent(take)}`,
        getLetters: () => 
            `/search/DownloadLetters`,
    },
} as const;

export type Api = typeof api;
export default api;
